import { api } from 'webReservations/api';

export interface NotificationSetting {
  enabled: boolean;
  name: string;
}

interface SMSNotificationSettings {
  settings: NotificationSetting[];
}

export interface UserAccountData {
  balance: number;
  linkedAccountId: string;
}

export const getSMSNotificationSettings =
  async (): Promise<SMSNotificationSettings> =>
    api.get(`/notification-settings`);

export const updateSMSNotificationSettings = async (
  settings: SMSNotificationSettings,
): Promise<void> => api.put(`/notification-settings`, settings);

export const getUserAccountData = async (): Promise<UserAccountData> =>
  api.get(`/user/account`);

export interface UpdateUserEmailResponse {
  id: string;
  email?: string;
  firstName: string;
  lastName: string;
  phone?: string;
  isRegistered: boolean;
}

export const updateUserEmail = async (
  email: string,
): Promise<UpdateUserEmailResponse> => api.put('/user/email', { email });

export const transferBalance = async (): Promise<void> =>
  api.post('/payouts/transfer');

export const deleteBankAccount = async (): Promise<void> =>
  api.delete('/payouts/linked-account');

export interface RestaurantMarketingOptIn {
  restaurantId: string;
  restaurantName: string;
}

export const getGuestMarketingOptIns = async (): Promise<
  RestaurantMarketingOptIn[]
> => api.get('/guest-marketing-opt-ins');

export const deleteGuestMarketingOptIn = async (
  restaurantId: string,
): Promise<void> => api.delete(`/guest-marketing-opt-ins/${restaurantId}`);
